module.exports = __webpack_public_path__ + "img/logo.45fb4d0b.png";